import React from "react"
import { useTranslation } from "react-i18next"
import Lottie from "react-lottie"
import { successTick } from "../../animation"
import "./SuccessAssets.css"

export default function SuccessAssets(this: any) {
  const { t } = useTranslation()
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: successTick,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  }
  return (
    <div className="container-center">
      <Lottie options={defaultOptions} width="12em" height="12em" />
      <div className="success-info-header">
        {t("information_shared_to_shipper")}
      </div>
      <div className="success-info-text">
        {t("information_shared_securely_msg")}
      </div>
      <div className="success-close-text">{t("close_the_page_text")}</div>
    </div>
  )
}
